import { Component, Host, Method, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'ico-accordion',
  styleUrl: 'ico-accordion.css',
})
export class IcoAccordion {
  @Prop() dataTestId: string = '';
  @Prop() callbackExpand: Function = () => {};
  @Prop() callbackCollapse: Function = () => {};

  @Prop() headerText: string = '';

  @State() isOpen: boolean = false;
  @Method()
  async open(ev) {
    this.isOpen = true;
    this.callbackExpand(ev);
  }

  @Method()
  async close(ev) {
    this.isOpen = false;
    this.callbackCollapse(ev);
  }

  onHeaderClick = (ev) => {
    if (this.isOpen) {
      this.close(ev);
    } else {
      this.open(ev);
    }
  };

  render() {
    const backGroundClasses = {
      'rounded transition-all duration-200 bg-clrs-off-white': true,
      'hover:bg-clrs-kbb-dovegrey': true,
    };
    const headerClasses = {
      'flex px-3 py-4 items-center transition-all duration-200 cursor-pointer outline-none focus:shadow-accordion': true,
      'focus:shadow-accordion': this.isOpen,
    };
    const slotContainerClasses = {
      'ml-12 mr-8 transition-[max-h] duration-500 overflow-hidden': true,
      'max-h-0': !this.isOpen,
    };
    return (
      <Host>
        <div class={backGroundClasses}>
          <div tabindex="0" class={headerClasses} onClick={this.onHeaderClick}>
            <div>
              {!this.isOpen && <icon-chevron-down />}
              {this.isOpen && <icon-chevron-up />}
            </div>
            <div class="ml-4 font-montserrat font-semibold text-lg leading-6">{this.headerText}</div>
          </div>
          <div class={slotContainerClasses}>
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
